const subscriptionPlans = {
  valueMustBeInteger: "يجب أن يكون الرقم صحيحًا (بدون كسور)",
  WillBeDeletedAfterSaving: "سيتم الحذف بعد الحفظ",
  SaveChanges: "حفظ التغييرات",
  YouAreAboutToSaveChanges:
    "أنت على وشك حفظ {{count}} تغير{{count > 1 ? 'ات' : ''}}. إليك ما سيتم تطبيقه:",
  NewPlans: "الخطط الجديدة",
  UpdatedPlans: "الخطط المحدثة",
  DeletedPlans: "الخطط المحذوفة",
  Cancel: "إلغاء",
  Confirm: "تأكيد",
  ThisActionCannotBeUndone:
    "هذا الإجراء لا يمكن التراجع عنه. يرجى مراجعة التغييرات بعناية.",
  planName: "اسم الباقة",
  plan: "الباقة {{index}}",
  usersPay: "قيمة يدفعها المستخدم",
  choosePlanName: "اختر اسم الباقة",
  custom: "مخصص",
  planNameInEnglish: "اسم الباقة بالإنجليزية",
  planNameInArabic: "اسم الباقة بالعربية",
  planNamesMustBeDifferent:
    "يجب أن يكون اسم الباقة مختلفًا بين الإنجليزية والعربية",
  planTitleAlreadyExists:
    "يوجد اسم باقة مطابق مسبقًا. يرجى اختيار اسم مختلف.",
  choosePlanIcon: "اختر أيقونة الباقة",
  addCustomName: "إضافة اسم مخصص",
  createCustomPlanName: "إنشاء اسم الباقة المخصصة",
  create: "إنشاء",
  change: "تغيير",
  emoji: "إيموجي",
  chooseSubscriptionImage: "اختر صورة الاشتراك",
  chooseSubscriptionImageDescription:
    "اختر صورة غلاف لباقات الاشتراك، أو ارفع صورة مخصصة.",
  cropImage: "اقتطاع الصورة",
  cropAndSave: "قص وحفظ",
  saving: "جارٍ الحفظ…",
  deleteCover: "حذف صورة الغلاف",
  uploadImage: "رفع صورة",
  uploadImageHint: "PNG, JPG, GIF حتى 4 ميجابايت",
  foodImage: "صورة الطعام",
  coffeeImage: "صورة القهوة",
  fileTooSmall: "يجب أن تكون الصورة 4 كيلوبايت على الأقل",
  fileTooLarge: "يجب ألا تتجاوز الصورة 4 ميجابايت",
  imageProcessingError: "تعذر معالجة الصورة. يرجى المحاولة مرة أخرى.",
  unsupportedFileType: "يرجى رفع صورة بصيغة PNG أو JPG أو GIF",
  usersReceive: "رصيد يحصل عليه المستخدم",
  bonusPercentage: "نسبة المكافأة",
  addNewPlan: "إضافة باقة جديدة",
  save: "حفظ",
  allowMonthlySubscriptionPlans: "تفعيل الباقات الشهرية",
  allowMonthlySubscriptionPlansDescription:
    "يحصل المستخدمون على رصيد إضافي في المحفظة عند الاشتراك في\n باقة شهرية. وفي حال اختيار باقة بدون انتهاء،\n سيتم خصم الرصيد الإضافي.",
  amountCannotExceed: "المبلغ لا يمكن أن يتجاوز {{amount}}",
  percentageCannotExceed: "النسبة لا يمكن أن تتجاوز 100٪",
  priceMustBeGreaterThan0: "يجب أن تكون القيمة أكبر من 0",
  required: "حقل إلزامي",
  amountAfterBonusCannotBeZero: "يجب أن تكون القيمة أكبر من 0",
  amountAfterBonusMustBeAtLeastPlanPrice: "يجب أن تكون القيمة على الأقل {{planPrice}}"
};

export default subscriptionPlans;
